import mixpanel from "mixpanel-browser";

export default function useMixPanel(event: string, payload?: any) {
  if (process.env.NODE_ENV === "development") {
    return;
  }

  const currentUserEmail = localStorage.getItem("ts_user_email") ?? "";
  const tsVisitorId = localStorage.getItem("ts_visitor_id") ?? "";
  const opentokClientId = localStorage.getItem("opentok_client_id") ?? "";

  const mixpanelToken = process.env.MIXPANEL_PROJECT_TOKEN;

  if (!mixpanelToken) {
    console.error("Mixpanel token not found.");
    return;
  }

  try {
    mixpanel.init(mixpanelToken);
    mixpanel.track(event, {
      ts_visitor_id: tsVisitorId,
      opentok_client_id: opentokClientId,
      current_user: currentUserEmail,
      ...payload,
    });
  } catch (error) {
    console.error("Failed to send event to Mixpanel:", error);
  }
}
